<template>
  <b-card header-tag="header" footer-tag="footer" class="shadow w-md-50">

    <!-- Modals -->
    <!-- <ClientAddModal id="addClientModal" @ok="getAllClients"></ClientAddModal> -->

    <template v-slot:header>
      <h6 class="m-0 font-weight-bold text-site-primary">Exams</h6>
    </template>

    <b-card-text>
      <b-table
        hover
        :items="examList"
        primary-key="id"
        :fields="[
          {
            key: 'id',
            label: 'ID',
            sortable: true
          },
          {
            key: 'name',
            label: 'Name',
            sortable: true
          },
          {
            key: 'shortName',
            sortable: true,
          },
        ]"
      >
      </b-table>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: `ExamList`,
  data() {
    return {
      examList: null,
    };
  },
  mounted() {
    this.getAllExams();
  },
  methods: {
    getAllExams() {
      this.$store
        .dispatch("exam/getAll")
        .then((data) => (this.examList = data.data));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>